export default [
  { routeName: "centersEdit", tabTitle: "Datos del centro" },
  { routeName: "centers-contacts", tabTitle: "Contactos" },
  { routeName: "centers-clientNotices", tabTitle: "Avisos" },
];
